export const colorDetail = '#4CCA51'
export const colorInteriorBack = '#E6EFE6'
export const colorballs = '#02BC79'
export const colorSchemaBt = 'green'


// export const colorDetail = '#fcbf14'
// export const colorInteriorBack = '#D3D3D3'
// export const colorballs = '#ffa500'
// export const colorSchemaBt = 'whatsapp'